import { FreeWheelGPDR } from 'services/FreeWheelGPDR';

export const fwGDPRPromise = (() => {
    return new Promise((resolve) => {
        window.cbsoptanon = window.cbsoptanon || { cmd: [] };
        window.cbsoptanon.cmd.push((cmp) => {
            const freeWheelHandler = new FreeWheelGPDR(cmp);
            freeWheelHandler.getGPDRData().then((freeWheelData) => resolve(freeWheelData));
        });
    });
})();

window.CBS.Registry.fwGPDRPromise = fwGDPRPromise;
